<template>
  <el-switch @change="change" v-model="isRateActive"></el-switch>
</template>

<script>
export default {
  data() {
    return {
      isRateActive: false
    }
  },
  beforeMount() {
    this.isRateActive = (this.params.data.isActive === 1)
  },
  methods: {
    change(val) {
      let params = {
        value: val,
        id: this.params.data.id
      }
      this.params.props.actionsHandler('setIsRateActive', params)
    }
  }
}
</script>
